export const TICKER_ITEMS: string[] = [
  'Улучшился результат по запросу «Купить iPhone» 8 → 7',
  'Доля запросов с нашей выдачей в мониторинге e-commerce увеличилась на 7%',
  'Эксперимент «Подбор заголовков» завершён: прирост CTR +4,2%',
  'Завершена регулярная прокачка по группе «Электроника» (42 запроса)',
  'Позиция по запросу «купить ноутбук для работы» поднялась 12 → 9',
  'В корзине «Осень 2026» собрано 18 новых запросов',
  'Новый эксперимент «Оптимизация мета-описаний» добавлен в очередь',
  'Подключение «Яндекс.Метрика» успешно синхронизировано',
];
